export interface Contacto {
  personaId: string;
  email: string;
  telefono: string;
  celular: string;
  domicilio: string;
  ciudad: string;
  departamentoId: string;
}
